<div
  [cxFocus]="focusConfig"
  (esc)="close('Escape clicked')"
  class="cx-import-entries-dialog"
>
  <div class="cx-import-entries-container">
    <!-- Modal Header -->
    <div class="modal-header cx-import-entries-header">
      <ng-container>
        <div class="cx-import-entries-title modal-title">
          {{ 'importEntriesDialog.importProducts' | cxTranslate }}
        </div>
      </ng-container>

      <button
        (click)="close('Close Import Products Dialog')"
        [attr.aria-label]="'importEntriesDialog.close' | cxTranslate"
        class="cx-import-entries-close close"
        type="button"
        [disabled]="(summary$ | async)?.loading"
      >
        <span aria-hidden="true">
          <cx-icon [type]="iconTypes.CLOSE"></cx-icon>
        </span>
      </button>
    </div>

    <!-- Modal Body -->
    <ng-container *ngIf="context$ | async as context">
      <ng-container *ngIf="formState; else importSummary">
        <cx-import-to-new-saved-cart-form
          *ngIf="isNewCartForm(context); else reducedForm"
          [type]="context.type"
          (submitEvent)="importProducts(context, $event)"
        ></cx-import-to-new-saved-cart-form>
        <ng-template #reducedForm>
          <cx-import-entries-form
            [type]="context.type"
            (submitEvent)="importProducts(context, $event)"
          ></cx-import-entries-form>
        </ng-template>
      </ng-container>

      <ng-template #importSummary>
        <cx-import-entries-summary
          [summary]="summary$ | async"
          [type]="context.type"
          (closeEvent)="close('Close Import Products Dialog')"
        ></cx-import-entries-summary>
      </ng-template>
    </ng-container>
  </div>
</div>
